import {
  DetailedHTMLProps,
  ImgHTMLAttributes,
  useEffect,
  useState,
} from "react";
import { Loader, Spinner } from "./Loader";
import { pause } from "../utils";

export const ImageWithLoading = ({
  listThumb,
  ...props
}: DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> & {
  listThumb?: boolean;
}) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    loadImage(0);
  }, [props.src]);

  const loadImage = async (tries: number) => {
    try {
      setLoading(true);
      const tempImg = new Image();
      tempImg.onload = () => {
        setLoading(false);
        setError(false);
      };
      tempImg.onerror = async () => {
        await pause(3000);
        if (tries < 2) {
          loadImage(tries + 1);
        } else {
          setError(true);
          setLoading(false);
        }
      };
      tempImg.src = props.src || "";
    } finally {
    }
  };

  return loading === true ? (
    <div className="w-full h-full grid grid-rows gap-2 content-center text-gray-500">
      {listThumb ? <Spinner /> : <Loader />}
    </div>
  ) : error ? (
    <div className="w-full h-full grid content-center text-gray-500">
      {!listThumb && (
        <div className="text-xs text-center px-4">Could not load image</div>
      )}
    </div>
  ) : (
    <img {...props} />
  );
};
